<template>
    <v-dialog v-model="shows" width="560" content-class="rounded-0">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card rounded="0">
            <v-card-title class="pa-24">
                <h5 class="tit-txt">
                    {{ item?.name || "-" }}
                </h5>
                <v-spacer />
                <v-btn text fab tile class="my-n24 mr-n18" @click="shows = false"> <v-icon>mdi-close</v-icon> </v-btn>
            </v-card-title>
            <v-card-text class="px-24 pb-24 white-space-pre-line">
                <p class="page-text--sm color-grey">
                    {{ item?.detail || "-" }}
                </p>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        item: { type: Object, default: () => ({}) },
    },
    data: () => ({
        shows: false,
    }),
};
</script>

<style lang="scss" scoped>
.white-space-pre-line {
    white-space: pre-line;
}
</style>